import { useState } from 'react'
import { ArrayParam, StringParam, useQueryParams } from 'use-query-params'

import { useQueryList } from '@percent/utility'
import { useServices } from '@percent/admin-dashboard/containers/service/ServiceContext'
import type { Form } from '@percent/admin-dashboard/api/actions/grantProgram/grantProgram.types'
import { FormsTable } from './formsTable/FormsTable'
import { CreateFormModal } from './createFormModal/CreateFormModal'
import { EditFormModal } from './editFormModal/EditFormModal'

const FORMS_PAGE_SIZE = 25

export function FormsListContainer() {
  const { grantProgramService } = useServices()
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false)
  const [editingForm, setEditingForm] = useState<Form | null>(null)

  const [queryParams, setQueryParams] = useQueryParams({
    partnerId: StringParam,
    search: StringParam,
    formIds: ArrayParam
  })

  const formIds = queryParams.formIds?.filter((id): id is string => id != null) ?? []

  const [{ totalResults, isLoading, data }, { nextPage, previousPage, refresh }] = useQueryList(
    ['/v1/admin/grants/forms', queryParams.partnerId, queryParams.search, formIds],
    grantProgramService.getFormsList,
    {
      pageSize: FORMS_PAGE_SIZE,
      partnerId: queryParams.partnerId ?? undefined,
      internalName: queryParams.search && queryParams.search.length >= 3 ? queryParams.search : undefined,
      formIds: formIds.length > 0 ? formIds : undefined
    }
  )

  return (
    <>
      <FormsTable
        data={data ?? []}
        totalResults={totalResults}
        isLoading={isLoading}
        nextPage={nextPage}
        previousPage={previousPage}
        queryParams={queryParams}
        setQueryParams={setQueryParams}
        onCreateForm={() => setIsCreateModalOpen(true)}
        onEditForm={setEditingForm}
      />
      <CreateFormModal isOpen={isCreateModalOpen} onClose={() => setIsCreateModalOpen(false)} refresh={refresh} />
      <EditFormModal
        isOpen={editingForm !== null}
        onClose={() => setEditingForm(null)}
        refresh={refresh}
        form={editingForm}
      />
    </>
  )
}
